import React from 'react';
import { GlobalProvider } from '../context/GlobalContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from '../pages/Home';
import Layout from '../components/Layout';
import LoginRoute from '../components/LoginRoute';
import RegisterRoute from '../components/RegisterRoute';
import LayoutDashboard from '../components/LayoutDashboard';
import DataTable from '../components/DataTable';
import DataForm from '../components/DataForm';
import Profile from '../components/Profile';
import ChangePass from '../components/ChangePass';
import Navbar from '../components/Navbar';
import Dashboard from '../pages/Dashboard';
import DashboardRoute from '../components/DashboardRoute';
import DetailPage from '../pages/DetailPage';
import Page404 from '../components/Page404';

const Routers = () => {
  return (
    <>
      <BrowserRouter>
        <GlobalProvider>
          <Routes>
            <Route path="*" element={<Page404 />} />
            <Route
              path="/"
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />
            <Route
              path="/job/:id"
              element={
                <Layout>
                  <DetailPage />
                </Layout>
              }
            />
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/register" element={<RegisterRoute />} />

            <Route
              path="/dashboard"
              element={
                <DashboardRoute>
                  <LayoutDashboard>
                    <Dashboard />
                  </LayoutDashboard>
                </DashboardRoute>
              }
            />
            <Route
              path="/dashboard/list-job-vacancy"
              element={
                <DashboardRoute>
                  <LayoutDashboard>
                    <DataTable />
                  </LayoutDashboard>
                </DashboardRoute>
              }
            />
            <Route
              path="/dashboard/list-job-vacancy/form"
              element={
                <DashboardRoute>
                  <LayoutDashboard>
                    <DataForm />
                  </LayoutDashboard>
                </DashboardRoute>
              }
            />
            <Route
              path="/dashboard/list-job-vacancy/form/edit/:IdData"
              element={
                <DashboardRoute>
                  <LayoutDashboard>
                    <DataForm />
                  </LayoutDashboard>
                </DashboardRoute>
              }
            />
            <Route
              path="/dashboard/profile"
              element={
                <DashboardRoute>
                  <LayoutDashboard>
                    <Profile />
                  </LayoutDashboard>
                </DashboardRoute>
              }
            />
            <Route
              path="/dashboard/change-password"
              element={
                <DashboardRoute>
                  <LayoutDashboard>
                    <ChangePass />
                  </LayoutDashboard>
                </DashboardRoute>
              }
            />
          </Routes>
        </GlobalProvider>
      </BrowserRouter>
    </>
  );
};

export default Routers;
